export default "__VITE_ASSET__rNBvlb5H__"